<template>
  <div class="py-4 container-fluid">
    <div class="card shadow-lg mt-n4">
      <div class="card-body p-3">
        <!-- Header con titolo e bottone aggiungi -->
        <div class="row align-items-center mb-3">
          <!-- Titolo a sinistra -->
          <div class="col-lg-9 col-md-8 col-sm-12">
            <header-title :title="'Lista tubi FluorTecno'"></header-title>
          </div>
          
          <!-- Bottone Aggiungi a destra -->
          <div class="col-lg-3 col-md-4 col-sm-12 text-end">
            <button class="btn btn-outline-warning btn-sm" @click="openModal()">
              <i class="fa fa-plus me-1"></i> Aggiungi
            </button>
          </div>
          <!-- Modale per aggiungere/modificare tubo -->
          <tubefl-modal
            :is-open="isModalOpen"
            :idTubeFL="selectedTubeFLId"
            @close="closeModal"
            @saved="handleTubeSaved"
          />
        </div>

        <!-- Form di ricerca -->
        <div class="row">
          <div class="col-12">
            <!-- <vee-form @submit="searchTubeFL">
              <div class="d-flex gap-2 align-items-center">
                <vee-field 
                  type="text" 
                  name="cerca" 
                  class="form-control form-control-sm flex-grow-1" 
                  placeholder="Cerca tubo FluorTecno..."
                />
                <argon-button
                  size="sm"
                  variant="gradient"
                  color="primary"
                >
                  Cerca
                </argon-button>
              </div>
            </vee-form> -->
            <vee-form @submit="searchTubeFL">
              <div class="row g-2">
                <div class="col-md-3">
                  <vee-field 
                    type="text" 
                    name="factory_number" 
                    class="form-control form-control-sm" 
                    placeholder="Numero di fabbrica..."
                    v-model="searchFilters.factory_number"
                  />
                </div>
                <div class="col-md-3">
                  <vee-field 
                    type="text" 
                    name="serial_number" 
                    class="form-control form-control-sm" 
                    placeholder="Numero di matricola..."
                    v-model="searchFilters.serial_number"
                  />
                </div>
                <div class="col-md-3">
                  <vee-field 
                    type="text" 
                    name="client_code" 
                    class="form-control form-control-sm" 
                    placeholder="Codice cliente..."
                    v-model="searchFilters.client_code"
                  />
                </div>
                <div class="col-md-3 d-flex gap-2">
                  <argon-button
                    size="sm"
                    variant="gradient"
                    color="primary"
                    class="flex-grow-1"
                    type="submit"
                  >
                    <i class="fa fa-search me-1"></i> Cerca
                  </argon-button>
                  <!-- <argon-button
                    size="sm"
                    variant="outline"
                    color="secondary"
                    type="button"
                    @click="resetSearch"
                  >
                    <i class="fa fa-times me-1"></i> Reset
                  </argon-button> -->
                </div>
              </div>
            </vee-form>
          </div>
        </div>
      </div>
    </div>
  </div>
 
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <tubefl-table 
          :tubeflListProp="tubeFLList" v-if="this.tubeFLList && !this.search_tubefl"
          @tubeUpdated="handleTubeUpdatedFromTable"
          @tubeDeleted="handleTubeDeletedFromTable"
        />
        <div v-if="total > pagination_size" class="col-12">
          <app-pagination
            :total-items="total"
            :items-per-page="pagination_size"
            @getPaginationItems="getPaginationTubeFL"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import ArgonButton from "@/components/ArgonButton.vue";
import AppPagination from "@/components/Pagination.vue";
import { setItem, getItem, removeItem } from "@/utility/localStorageControl";
import HeaderTitle from "@/components/Header/HeaderTitle.vue";
import TubeflTable from "@/views/tubefl/tubeFLTable.vue";
import TubeflModal from "@/views/tubefl/tubeFLModal.vue";

export default {
  name: "list-tubefl",
  components: {
    HeaderTitle,
    AppPagination,
    ArgonButton,
    TubeflTable,
    TubeflModal
  },
  data() {
    return {
      tubeFLList: null,
      search_tubefl: false,
      pages: 0,
      total: 0,
      pagination_size: 1,
      isModalOpen: false,
      selectedTubeFLId: null,
      searchFilters: {
        factory_number: '',
        serial_number: '',
        client_code: ''
      }
    };
  },
  mounted() {
    this.loadSearchFilters();
    this.getTubeFLList();
  },
  methods: {
    async getTubeFLList() {
      try {
        const response = await axios.get(this.$endpoint + "/tubefl/list", {
          params: {
            page: 1,
            size: this.pagination_size,
          },
          headers: {
            authorization: process.env.VUE_APP_APY_KEY,
          },
        });

        this.tubeFLList = response.data.data;
        this.total = response.data.total;
        this.pages = response.data.pages;
      } catch (ex) {
        console.log(ex);
      }
    },
    async searchTubeFL() {
      let loader;
      try {
        loader = this.$loading.show({
          loader: "dots",
          color: "#2dce89",
        });
        this.search_tubefl = true;
        
        const params = {};
        
        // Aggiungi solo i parametri valorizzati
        if (this.searchFilters.factory_number && this.searchFilters.factory_number.trim() !== '') {
          params.factory_number = this.searchFilters.factory_number.trim();
        }
        if (this.searchFilters.serial_number && this.searchFilters.serial_number.trim() !== '') {
          params.serial_number = this.searchFilters.serial_number.trim();
        }
        if (this.searchFilters.client_code && this.searchFilters.client_code.trim() !== '') {
          params.client_code = this.searchFilters.client_code.trim();
        }
        
        const response = await axios.get(this.$endpoint + "/tubefl/list", {
          params: params,
          headers: {
            authorization: process.env.VUE_APP_APY_KEY,
          },
        });
        
        this.tubeFLList = response.data.data;
        this.total = response.data.total;
        this.search_tubefl = false;

        // Salva i filtri di ricerca nel localStorage
        this.saveSearchFilters();
        
        loader.hide();
      } catch (ex) {
        console.log(ex);
        loader?.hide();
      }
    },
    async getPaginationTubeFL(page) {
      try {
        const params = {
          page: page,
          size: this.pagination_size,
        };
        
        // Aggiungi i filtri salvati
        if (this.searchFilters.factory_number) {
          params.factory_number = this.searchFilters.factory_number;
        }
        if (this.searchFilters.serial_number) {
          params.serial_number = this.searchFilters.serial_number;
        }
        if (this.searchFilters.client_code) {
          params.client_code = this.searchFilters.client_code;
        }
        
        const response = await axios.get(this.$endpoint + "/tubefl/list", {
          params: params,
          headers: {
            authorization: process.env.VUE_APP_APY_KEY,
          },
        });
        
        this.tubeFLList = response.data.data;
        this.total = response.data.total;
      } catch (ex) {
        console.log(ex);
      }
    },
    resetSearch() {
      // Resetta i filtri
      this.searchFilters = {
        factory_number: '',
        serial_number: '',
        client_code: ''
      };
      
      // Rimuovi i filtri dal localStorage
      removeItem('search_tubefl_filters');
      
      // Ricarica la lista senza filtri
      this.getTubeFLList();
    },
    saveSearchFilters() {
      // Salva i filtri nel localStorage
      setItem('search_tubefl_filters', JSON.stringify(this.searchFilters));
    },
    loadSearchFilters() {
      // Carica i filtri dal localStorage se esistono
      const savedFilters = getItem('search_tubefl_filters');
      if (savedFilters) {
        try {
          this.searchFilters = JSON.parse(savedFilters);
        } catch (e) {
          console.error('Errore nel caricamento dei filtri salvati:', e);
        }
      }
    },
    openModal(tubeId = null) {
      this.selectedTubeId = tubeId;
      this.isModalOpen = true;
    },
    closeModal() {
      this.isModalOpen = false;
      this.selectedTubeId = null;
    },
    async handleTubeSaved(savedTube) {
      await this.getTubeFLList();
    },
    async handleTubeUpdatedFromTable(updatedTube) {
      if (updatedTube && updatedTube._id) {
        const index = this.tubeFLList.findIndex(tube => tube._id === updatedTube._id);
        if (index !== -1) {
          this.tubeFLList[index] = updatedTube;
        }
      }
    },
    handleTubeDeletedFromTable(deletedTubeId) {
      // Rimuovi l'elemento dalla lista
      const index = this.tubeFLList.findIndex(tube => tube._id === deletedTubeId);
      if (index !== -1) {
        this.tubeFLList.splice(index, 1);
        this.total--;
      }
    },
  },
};
</script>

<style>
ul li input[type="text"] {
  display: block;
}

.search-field {
  display: inline;
  width: 85%;
  padding: 0.5rem 0.75rem;
  margin-right: 0.5rem;
  font-weight: 400;
  font-size: 0.75rem;
  line-height: 0.8rem;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #d2d6da;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  border-radius: 0.5rem;
  transition: box-shadow 0.15s ease, border-color 0.15s ease;
}

.text-right {
  text-align: right;
}
</style>
